// src/services/accessService.js
import axios from "axios";
import { buildHeaders } from "./_headers.util";
import { resolveApiBaseUrl } from "@/utils/hostname";

export default {
  getAccess() {
    return axios.get(`${resolveApiBaseUrl()}me/access`, {
      headers: buildHeaders(),
    });
  },
};
